import React from 'react';
import { CreditCard } from 'lucide-react';

const Payments = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <CreditCard size={32} className="page-icon" />
        <h1 className="page-title">Payments</h1>
      </div>
      <div className="page-content">
        <p className="page-description">View and manage payment transactions.</p>
        {/* Payments module content will go here */}
      </div>
    </div>
  );
};

export default Payments;